import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import * as action from '../../home/redux/actions';
import * as commonActoins from '../../common/redux/actions';
import * as homeActions from '../../home/redux/apiCall';
import * as serviceActions from '../../Pasajebus/PasajebusServiceList/redux/actions';

import React, { useEffect, useState } from 'react';

import AmenitiesStrip from '../AmenitiesStrip/AmenitiesStrip';
import { AppData } from '../../../services';
import CommonService from '../../../services/commonService';
import DateService from '../../../services/dateService';
import Slider from 'react-slick';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

// Import css files

const renderItems = (items, history) => {
  console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>', items);

  // items = items ? [...items, ...items, ...items, ...items, ...items, ...items] : [];
  return (
    <div className="slider-container">
      <Slider
        // dots={true}
        slidesToShow={5}
        slidesToScroll={5}
        infinite={items && items.length > 5}
      >
        {items &&
          items.map(item => {
            return (
              <div
                className="destinations-item mb10"
                // onClick={() => {
                //   sessionStorage.removeItem('confirmTicketData');
                //   sessionStorage.removeItem('changeTicketDetailsResponse');
                //   sessionStorage.removeItem('confirmTicketDataResponse');
                //   let source =
                //     items &&
                //     item.origin_name
                //       .toLowerCase()
                //       .replace(/-/g, '_')
                //       .replace(/ /g, '-')
                //       .replace(/_/g, '--');
                //   let dest =
                //     items &&
                //     item.destination_name
                //       .toLowerCase()
                //       .replace(/-/g, '_')
                //       .replace(/ /g, '-')
                //       .replace(/_/g, '--');
                //   history.push(
                //     `/${
                //       i18next.language == 'es' ? 'es/pasajes-bus/' : 'en/bus-tickets/'
                //     }${source},chile/${dest},chile/${DateService.getTodayString()}`,
                //   );
                // }}
              >
                <div>
                  <img src={items && item.image_url} className="d-inline-block" width="100%" />
                  {/* <span className=" destinations-origin-destination text-white font10 bold-text d-inline-block w-100 py-2 text-center">
                    {`${items && item.origin_name} ${
                      i18next.language === 'es' ? 'a' : 'to'
                    } ${items && item.destination_name}`}
                  </span> */}
                  {/* <div className="destination-min-fare py-3 font10 text-bold text-uppercase text-center ">
                  <span className="span-1">Desde</span>{' '}
                  <span className="span-2">{CommonService.currency(items && item.min_fare)}</span>
                </div> */}
                </div>
              </div>
            );
          })}
      </Slider>
    </div>
  );

  // return (
  //   <div
  //     className={`d-flex flex-row ${items && items.length <= 4 ? 'justify-content-center' : ''}`}
  //     style={
  //       items && items.length <= 4
  //         ? {
  //             paddingBottom: 10,
  //           }
  //         : {
  //             overflowX: 'scroll',
  //             width: '100%',
  //             paddingBottom: 10,
  //           }
  //     }
  //   >
  //     {items &&
  //       items.map(item => {
  //         return (
  //           <React.Fragment>
  //             <div
  //               className="destinations-item mb10 d-flex flex-row mx-3"
  //               style={{ width: '18%' }}
  //               onClick={() => {
  //                 sessionStorage.removeItem('confirmTicketData');
  //                 sessionStorage.removeItem('changeTicketDetailsResponse');
  //                 sessionStorage.removeItem('confirmTicketDataResponse');
  //                 let source = item.origin_name
  //                   .toLowerCase()
  //                   .replace(/-/g, '_')
  //                   .replace(/ /g, '-')
  //                   .replace(/_/g, '--');
  //                 let dest = item.destination_name
  //                   .toLowerCase()
  //                   .replace(/-/g, '_')
  //                   .replace(/ /g, '-')
  //                   .replace(/_/g, '--');
  //                 history.push(
  //                   `/${
  //                     i18next.language == 'es' ? 'es/pasajes-bus/' : 'en/bus-tickets/'
  //                   }${source},chile/${dest},chile/${DateService.getTodayString()}`,
  //                 );
  //               }}
  //             >
  //               <div>
  //                 <img src={item.image_url} className="d-inline-block" width="100%" />
  //                 <span className=" destinations-origin-destination text-white font10 bold-text d-inline-block w-100 py-2 text-center">
  //                   {/* {item.origin_name + ' to ' + item.destination_name} */}

  //                   {`${item.origin_name} ${i18next.language === 'es' ? 'a' : 'to'} ${
  //                     item.destination_name
  //                   }`}
  //                 </span>
  //                 <div className="destination-min-fare py-3 font10 text-bold text-uppercase text-center ">
  //                   <span className="span-1">Desde</span>{' '}
  //                   <span className="span-2">{CommonService.currency(item.min_fare)}</span>
  //                 </div>
  //               </div>
  //             </div>
  //           </React.Fragment>
  //         );
  //       })}
  //   </div>
  // );
};

const Destinations = ({ items, sectionTitle, sectionIntro, t, actions, history }) => {
  const [popularRoues, setPopularRoues] = useState(null);

  useEffect(() => {
    actions
      .apiCall({
        url: AppData.BASE_URL + 'api/pullman/base/popular_routes',
        method: 'GET',
      })
      .then(res => {
        console.log('Destinations Response ', res);
        setPopularRoues(res.data);
      });
    return () => {
      if (CommonService.clearSearchFunction) {
        CommonService.clearSearchFunction();
      }
      actions.setOnwardPbDate(DateService.getTodayString());
      actions.setReturnPbDate(null);
      actions.pbSetSourceCity(null);
      actions.pbSetDestinationCity(null);
      actions.setServiceListOnward(null);
      actions.setServiceListReturn(null);
    };
  }, []);

  // useEffect(() => {

  // }, []);

  return (
    <div
      style={{
        // backgroundColor: '#efefef',
        paddingTop: 30,
        borderRadius: 20,
      }}
      className="margin-B50 margin-T50"
    >
      <div
        className="content-container pullman-section-primary-row-container"
        style={{ marginBottom: '60px' }}
      >
        <div className="pullman-section-primary-row">
          <div className="pullman-section-primary-row-main-heading black-text">{sectionTitle}</div>
          <div className="pullman-section-primary-row-underline"></div>
          <div className="pullman-section-primary-row-sub-heading margin-T15 margin-B35">
            {sectionIntro}
          </div>
        </div>
        <div
          className="content-container w-100 content-container-destinations"
          // style={{ width: '103%' }}
        >
          {renderItems(popularRoues, history)}
        </div>
      </div>

      {/* <AmenitiesStrip t={t} /> */}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    pbPaymentDetails: state.pbPaymentDetails,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...homeActions, ...action, ...serviceActions, ...commonActoins },
      dispatch,
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(Destinations));



// WEBPACK FOOTER //
// ./src/features/home/Destinations/Destinations.js